import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import {
  Container,
  Heading,
  MainSection,
  WorkSection,
  CheckBoxWrapper,
  AddNewMsgModalWrapper,
} from "pages/Messages/Settings/SettingsStyled";
import {
  CircleBtn,
  AccordionStyled,
  MobileHeader,
  DialogContainer,
} from "assets/css/globle";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import SettingsTable from "pages/Messages/Settings/Table";

import AudioIcon from "assets/svgIcons/AudioIcon";
import { useSnackbar } from "notistack";

import ringer from "audio/Beep.mp3";

import ChatIcon from "assets/svgIcons/ChatDoubleIcon";

import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";

import { useHookstate } from "@hookstate/core";
import {
  MESSAGE_VDU_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  MESSAGE_FLEET_GLOBAL_STATES,
  ADS_GLOBAL_STATE,
  SIDENAV_GLOBAL_STATE,
  SITELOCATION_GLOBAL_STATE,
  COMMON_COMPONENTS_STATES,
} from "../../../globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "assets/svgIcons/CloseIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import RadioCheckIcon from "assets/svgIcons/RadioCheckedIcon";
import RadioUncheckIcon from "assets/svgIcons/RadioUncheckIcon";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { SelectTagCar } from "../../../commonComponents/SideNav/subSectionNav/Map/MapStyled";
import {
  Button,
  Dialog,
  DialogActions,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useCallback } from "react";
import {
  setBeepOnNewMessageAction,
  setBeepWhileNotEmptyAction,
  setPopupOnNewMessageAction,
} from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly } from "constant";
import { useNavigate } from "react-router-dom";

export const Settings = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { enqueueSnackbar } = useSnackbar();
  const audio = new Audio(ringer);
  // states
  const [priority, setPriority] = useState(false);
  const [okResponse, setOkResponse] = useState(false);
  const [yesNoResponse, setYesNoResponse] = useState(false);
  const [noneResponse, setNoneResponse] = useState(true);
  const [alertResponse, setAlertResponse] = useState(false);
  const [msgCloseBtn, setMsgCloseBtn] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);

  const {
    getMessagesFromCarsData,
    siteSettingsData,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || [];

  const {
    beepOnNewMessage,
    beepWhileNotEmpty,
    popupOnNewMessage,
  } = useSelector((state) => state.firstReducer) || [];

  const [messageData, setMessageData] = useState([]);

  const { messageBadgeCount } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const { redirectState, alertMsg, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
  const { sideDrawerActiveTabState, subNavDataState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
  const { showTagCarsState } = useHookstate(COMMON_COMPONENTS_STATES);
  const dispatch = useDispatch();

  const {
    globalMessageBoxOpenClose,
    globalMessageText,
    globalMessagePriorityAlert,
    globalMessageId,
    setSave,
  } = useHookstate(MESSAGE_VDU_GLOBAL_STATE);
  const navigate = useNavigate();

  // handel Clear buttons
  useEffect(() => {
    dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  const handelMessageClearButton = () => {
    globalMessageText.set("");
    globalMessagePriorityAlert.set(null);
    setPriority(false);
    setNoneResponse(true);
    setOkResponse(false);
    setAlertResponse(false);
    setYesNoResponse(false);
    setSave.set(false);
  };

  const handelSaveButton = (
    Id,
    Body,
    getPriority,
    getAlertResponse,
    getOkResponse,
    getYesNoResponse
  ) => {
    if (Body.length > 0) {
      let payload = {
        Body: Body,
        FromGroupId: 0,
        ToGroupId: 0,
        Audible: getAlertResponse,
        Priority: getPriority,
        YesNoResponse: getYesNoResponse,
        OkResponse: getOkResponse,
      };

      dispatch(
        COMMON_SERVICES.sendMessagesSettingServices(payload, siteId.get())
      )
        .then(() => {
          dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
        })
        .then(() => globalMessageBoxOpenClose.set(false));
      globalMessageText.set("");
      setSave.set(false);
    }
  };

  const toggleMessage = (e) => {
    e.stopPropagation();
    globalMessageBoxOpenClose.set(!globalMessageBoxOpenClose.get());
  };

  const oldest = moment(new Date()).format("YYYY-MM-DD");

  useEffect(() => {
    dispatch(COMMON_SERVICES.getMessagesFromCarsServices(oldest, siteId.get()));
  }, []);

  let newMessageAudio =
    localStorage.getItem("newMessageAudio") === "true" ? true : false;
  let inboxMessageAudio =
    localStorage.getItem("inboxMessageAudio") === "true" ? true : false;
  let popupNewMessage =
    localStorage.getItem("popupNewMessage") === "true" ? true : false;

  useEffect(() => {
    let messageDataGetter = [] || [];
    messageDataGetter =
      getMessagesFromCarsData &&
        getMessagesFromCarsData?.Messages &&
        getMessagesFromCarsData?.Messages?.length !== 0
        ? getMessagesFromCarsData?.Messages?.map((item, i) => {
          return {
            ...item,
          };
        })
        : "";
    setMessageData(messageDataGetter);
  }, []);

  const triggerSnackbar = (label) => {
    const val = messageBadgeCount.value;
    messageBadgeCount.set(val + 1);
    audio.play();
    enqueueSnackbar(
      label,

      {
        preventDuplicate: true,
        autoHideDuration: 10000,
        variant: "warning",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        sx: {
          "& .SnackbarContent-root": {
            color: "white",
            backgroundColor: "rgb(189, 54, 47)",
            width: 200,
            height: 100,
          },
        },
      }
    );
  };

  let messageResponse = {
    None: 0,
    Ok: 1,
    Yes: 2,
    No: 3,
  };

  let messageResponseText = function (response) {
    switch (response) {
      case messageResponse.None:
        return "-";
      case messageResponse.Ok:
        return "Ok";
      case messageResponse.Yes:
        return "Yes";
      case messageResponse.No:
        return "No";
      default:
        return "?";
    }
  };

  // Display pop-up (toast)
  function showPopUp() {
    // Format text to show call/response and location if appropriate
    messageData &&
      messageData.map((msg) => {
        let text = msg.Text;
        if (!msg.ToCar) {
          //format location info, if any
          let locationInfo;
          let courseInfo = msg.Course ? msg.Course : "";
          let holeInfo = msg.Hole ? msg.Hole : "";
          if (siteSettingsData.Courses.length > 1 && courseInfo && holeInfo) {
            locationInfo = courseInfo + holeInfo;
          } else {
            locationInfo = holeInfo ? holeInfo : "";
          }

          //format response info, if any
          let resp = messageResponseText(msg.Response);
          text =
            resp !== "-"
              ? locationInfo + text + resp
              : (text = locationInfo + text);
        }

        let sent = courseTimeMoment(msg.Created);
      });
  }

  function courseTimeMoment(utcDateTime) {
    let dt = moment.utc(utcDateTime);
    if (siteSettingsData) dt.utcOffset(siteSettingsData.TimeZoneOffset);
    return dt;
  }

  function newMessageAlert() {
    // Format text to show call/response and location if appropriate
    messageData &&
      messageData.map((msg) => {
        let text = msg.Text;
        if (!msg.ToCar) {
          //format location info, if any
          let locationInfo;
          let courseInfo = msg.Course ? msg.Course : "";
          let holeInfo = msg.Hole ? msg.Hole : "";
          if (siteSettingsData.Courses.length > 1 && courseInfo && holeInfo) {
            locationInfo = courseInfo + holeInfo;
          } else {
            locationInfo = holeInfo ? holeInfo : "";
          }

          //format response info, if any
          let resp = messageResponseText(msg.Response);
          text =
            resp !== "-"
              ? locationInfo + text + resp
              : (text = locationInfo + text);
        }

        audio.play();
      });
  }

  useEffect(() => {
    if (popupNewMessage) {
      showPopUp();
    }
    if (newMessageAudio && messageData.length > 0) newMessageAlert();
    if (inboxMessageAudio && messageData.length > 0) audio.play();
  }, [popupNewMessage, newMessageAudio, inboxMessageAudio]);

  useEffect(() => {
    !siteLocationGlobalData.get() &&
      messageData &&
      messageData.map((msg) => {
        let sent = courseTimeMoment(msg.Created);
        triggerSnackbar(
          audio.play()`From car ${msg.CarNum} @ ${sent.format("h:mm:a")} ${msg.Text
            }`
        );
      });
  }, [popupNewMessage]);

  const handleAlerts = useCallback(
    (e, detector) => {
      if (detector === "newMessage") {
        dispatch(setBeepOnNewMessageAction(e.target.checked));
      } else if (detector === "messageInInbox") {
        dispatch(setBeepWhileNotEmptyAction(e.target.checked));
      } else {
        dispatch(setPopupOnNewMessageAction(e.target.checked));
      }
    },
    [beepOnNewMessage, beepWhileNotEmpty, popupOnNewMessage]
  );

  const yesFunc = () => {
    alertMsg.set(false);
    globalMessageBoxOpenClose.set(false);
    setSave.set(false);
    globalMessageText.set("");

    if (msgCloseBtn) {
      setMsgCloseBtn(false);
    } else {
      redirectState.set(false);
      navigate(`/${nextStageName.get().toLowerCase()}`);
      let activeTab = nextTabIndex.get();
      let activeName = nextStageName.get();
      sideDrawerActiveTabState.set(activeTab);
      subNavDataState.set(activeName);

      localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

      localStorage.setItem("subNavState", "true");
      localStorage.setItem("subNavDataState", nextStageName.get());

      if (nextStageName.get() !== "FLEET") {
        showTagCarsState.set(false);
      }
    }
  };

  useEffect(() => {
    if (setSave.get()) redirectState.set(true);
    else redirectState.set(false);
  }, [setSave.get()]);

  const [addHeight, setAddHeight] = useState(false)

  const handleClickAddHeight = () => {
    setAddHeight(!addHeight);
  };

  return (
    <>
      <MobileHeader>
        <h4>{t("Settings")}</h4>
      </MobileHeader>
      <Container >
        <AccordionStyled>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              onClick={handleClickAddHeight}
            >
              <Heading>
                <h3>{t("Alerts")}</h3>
              </Heading>
            </AccordionSummary>
            <AccordionDetails>
              <WorkSection>
                <div>
                  <div>
                    <p className="text-with-icon">
                      <AudioIcon /> {t("Audible_alert")}
                    </p>
                    <Tooltip
                      title={t("When_new_message_received")}
                      placement="top"
                    >
                      <CheckBoxWrapper>
                        <FormControlLabel
                          label={t("When_new_message_received")}
                          control={
                            <Checkbox
                              checked={beepOnNewMessage}
                              onChange={(e) => handleAlerts(e, "newMessage")}
                              icon={<UnCheckIcon width={15} height={15} />}
                              checkedIcon={<CheckIcon width={15} height={15} />}
                            />
                          }
                        />
                      </CheckBoxWrapper>
                    </Tooltip>
                  </div>
                  <div>
                    <Tooltip
                      title={t("While_messages_in_Inbox")}
                      placement="top"
                    >
                      <CheckBoxWrapper>
                        <FormControlLabel
                          label={t("While_messages_in_Inbox")}
                          control={
                            <Checkbox
                              checked={beepWhileNotEmpty}
                              onChange={(e) =>
                                handleAlerts(e, "messageInInbox")
                              }
                              icon={<UnCheckIcon width={15} height={15} />}
                              checkedIcon={<CheckIcon width={15} height={15} />}
                            />
                          }
                        />
                      </CheckBoxWrapper>
                    </Tooltip>
                  </div>
                  <div>
                    <p className="text-with-icon">
                      <ChatIcon />
                      {t("Pop-up_alert")}
                    </p>
                    <Tooltip
                      title={t("When_new_message_received")}
                      placement="top"
                    >
                      <CheckBoxWrapper>
                        <FormControlLabel
                          label={t("When_new_message_received")}
                          control={
                            <Checkbox
                              checked={popupOnNewMessage}
                              onChange={(e) => handleAlerts(e, "popup")}
                              icon={<UnCheckIcon width={15} height={15} />}
                              checkedIcon={<CheckIcon width={15} height={15} />}
                            />
                          }
                        />
                      </CheckBoxWrapper>
                    </Tooltip>
                  </div>
                </div>
              </WorkSection>
            </AccordionDetails>
          </Accordion>
          <Accordion >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Heading>
                <h3>{t("Preset_messages")}</h3>
                <Tooltip title={t("Add_new_message")} placement="top">
                  <CircleBtn
                    disabled={
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className="add-new-msg"
                    onClick={(e) => toggleMessage(e)}
                  >
                    <AddIcon pointerEvents="none" />
                    {t("Add_new_message")}
                  </CircleBtn>
                </Tooltip>
              </Heading>
            </AccordionSummary>
            <AccordionDetails>
              <MainSection className={addHeight ? "" : "add-height"}>
                <SettingsTable />
              </MainSection>
            </AccordionDetails>
          </Accordion>
        </AccordionStyled>

        {/*  #################################################################### message modal open*/}
        {globalMessageBoxOpenClose.get() ? (
          <AddNewMsgModalWrapper>
            <SelectTagCar className="fleet-car-msg">
              <div className="inner-wrapper">
                <div className="box-heading">
                  <h5>{t("New_message")}</h5>
                  <CloseIcon
                    onClick={() => {
                      if (setSave.get()) {
                        setMsgCloseBtn(true);
                        alertMsg.set(true);
                      } else {
                        globalMessageBoxOpenClose.set(false);
                        setSave.set(false);
                      }
                    }}
                    width={22}
                    height={22}
                  />
                </div>
                <div className="text-area">
                  <textarea
                    maxLength={182}
                    id="w3review"
                    name="w3review"
                    rows="4"
                    placeholder={t("Type_your_message")}
                    value={globalMessageText.get()}
                    onChange={(e) => {
                      setSave.set(true);
                      globalMessageText.set(e.target.value);
                    }}
                  ></textarea>
                  {/* //########################checkboxes Starts################################// */}
                </div>
                <div className="checkbox-wrapper">
                  <FormGroup row>
                    <Tooltip title={t("Set_message_priority")} placement="top">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={priority}
                            onChange={(e) => setPriority(e.target.checked)}
                            inputProps={{ "aria-label": "controlled" }}
                            icon={<UnCheckIcon width={15} height={15} />}
                            checkedIcon={<CheckIcon width={15} height={15} />}
                          />
                        }
                        label={t("Priority")}
                      />
                    </Tooltip>
                    <Tooltip title={t("Set_sound_on_message")} placement="top">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={alertResponse}
                            onChange={(e) => setAlertResponse(e.target.checked)}
                            inputProps={{ "aria-label": "controlled" }}
                            icon={<UnCheckIcon width={15} height={15} />}
                            checkedIcon={<CheckIcon width={15} height={15} />}
                          />
                        }
                        label={t("Alert")}
                      />
                    </Tooltip>
                  </FormGroup>
                </div>
                <div className="response-section">
                  <p>{t("Response")}</p>
                  <div>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <Tooltip
                        title={t("Set_required_response_to_none")}
                        placement="top"
                      >
                        <FormControlLabel
                          value="noneResponse"
                          control={
                            <Radio
                              icon={<RadioUncheckIcon width={15} height={15} />}
                              checkedIcon={
                                <RadioCheckIcon width={15} height={15} />
                              }
                              checked={noneResponse}
                              onChange={(e) => {
                                setNoneResponse(e.target.checked);
                                setOkResponse(!e.target.checked);
                                setYesNoResponse(!e.target.checked);
                              }}
                            />
                          }
                          label={t("None")}
                        />
                      </Tooltip>
                      <Tooltip
                        title={t("Set_required_response_to_ok")}
                        placement="top"
                      >
                        <FormControlLabel
                          value="okResponse"
                          control={
                            <Radio
                              icon={<RadioUncheckIcon width={15} height={15} />}
                              checkedIcon={
                                <RadioCheckIcon width={15} height={15} />
                              }
                              onChange={(e) => {
                                setOkResponse(e.target.checked);
                                setNoneResponse(!e.target.checked);
                                setYesNoResponse(!e.target.checked);
                              }}
                              checked={okResponse}
                            />
                          }
                          label={t("Ok")}
                        />
                      </Tooltip>
                      <Tooltip
                        title={t("Set_required_response_to_yes/no")}
                        placement="top"
                      >
                        <FormControlLabel
                          value="yesNoResponse"
                          control={
                            <Radio
                              icon={<RadioUncheckIcon width={15} height={15} />}
                              checkedIcon={
                                <RadioCheckIcon width={15} height={15} />
                              }
                              checked={yesNoResponse}
                              onChange={(e) => {
                                setYesNoResponse(e.target.checked);
                                setNoneResponse(!e.target.checked);
                                setOkResponse(!e.target.checked);
                              }}
                            />
                          }
                          label={t("Yes/No")}
                        />
                      </Tooltip>
                    </RadioGroup>
                    {/* //########################checkboxes ends################################// */}
                  </div>
                  <div className="action-wrapper">
                    <Tooltip title={t("Save")} placement="top">
                      <button
                        style={{
                          pointerEvents:
                            setSave.get() === true ? "auto" : "none",
                        }}
                        className={
                          setSave.get() === true
                            ? "active send-btn"
                            : "disabled send-btn"
                        }
                        onClick={() =>
                          handelSaveButton(
                            globalMessageId.get(),
                            globalMessageText.get(),
                            priority,
                            alertResponse,
                            okResponse,
                            yesNoResponse
                          )
                        }
                      >
                        {t("Save")}
                      </button>
                    </Tooltip>
                    <Tooltip title="Clear" placement="top">
                      <button
                        className="send-btn"
                        onClick={() => handelMessageClearButton()}
                      >
                        {t("Clear")}
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </SelectTagCar>
          </AddNewMsgModalWrapper>
        ) : (
          //   </Box>
          // </Modal>
          <> </>
        )}
        {/* ###################################################################message modal close  */}

        <Dialog
          open={alertMsg.get()}
          onClose={() => {
            alertMsg.set(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth={fullWidth}
        >
          <DialogContainer>
            <h2 className="header">Confirm</h2>
            <p className="content">{t("Discard_changes")} ?</p>
            <DialogActions className="action-wrapper">
              <Button
                onClick={() => {
                  yesFunc();
                }}
              >
                Yes
              </Button>
              <Button
                onClick={() => {
                  alertMsg.set(false);
                }}
                autoFocus
              >
                No
              </Button>
            </DialogActions>
          </DialogContainer>
        </Dialog>
      </Container>
    </>
  );
};
